

const Joi = require('joi');
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./CompanyInfo.Validator.js";

class CompanyInfoAPI {


/*
POST http://45.124.86.67:3000/companyInfo/find
Content-Type: application/json

{
    "taxId":"0104585924"
}

*/

  find = async (data) => {
    const validator = Validator.VALIDATION_COMPANY_INFO_LIST;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/companyInfo/find", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

}
export default new CompanyInfoAPI();



// WEBPACK FOOTER //
// ./src/services/companyInfo/CompanyInfo.API.js